import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import queryKey from "configs/queryKey";
import { removeWhitelist } from "utils/apiService/Whitelist";

interface IProps {
  onClose: () => void;
  id: string;
}
const useRemoveWhitelist = ({ onClose, id }: IProps) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  return useMutation(async () => await removeWhitelist(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.WHITE_LIST]);
      onClose();
      toast({
        title: "Whitelist",
        description: "Remove a token successful",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    },
    onError: async (errors: any) => {
      const devMessage = errors?.response?.data?.devMessage || [];
      const errorMessage = errors?.response?.data?.errorMessage || "";
      const description = errorMessage + ":" + devMessage?.join(", ") || "";

      toast({
        title: "Whitelist.",
        description,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },
  });
};

export default useRemoveWhitelist;
